<template>
  <v-col cols="12">
    <p>
      Vyber si téma z menu nebo zkus FAQ
    </p>
    <h3 class="text-h5 font-weight-bold">FAQ</h3>
    
    <v-expansion-panels variant="accordion">
      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak mohu v robisu založit svůj oddíl?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Uživatelé sami nemohou oddíly zakládat. Vytvářet nové oddíly mohou pouze administrátoři robisu. Pokud chceš založit nový oddíl, kontaktuj nás na info@rob-is.cz
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak se přihlásím do robisu?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Přihlásit se můžeš pouze, pokud máš v robisu založený účet. Účet zakládá správce oddílu nebo jeho předseda. Pokud jsi členem oddílu, který je v robisu a účet nemáš, kontaktuj svého předsedu.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak se přihlásím na soutěž?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Pokud máš v robisu účet, přihlaš se nejdříve do něj. Pokud účet nemáš, dá se vytvořit jednorázová přihláška, kterou ale nebudeš moci editovat.<br>
          Poté si vyber akci z kalendáře a klikni na její název. Na stránce soutěže klikni na přihlásit se. Pokud tuto ikonu nevidíš, přihlášky buď nejsou otevřené, nebo už vypršel termín přihlášek.<br>
          Tlačítko tě přesměruje na stránku přihlášky. Pokud máš možnost některou přihlášku editovat, najdeš ji v horní části stránky. Pokud máš možnost někoho přihlásit, najdeš tuto možnost v dolní části stránky.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak přihlásím na soutěž někoho, kdo není v ROBISu registrovaný (např. člena rodiny)?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Pokud chceš přihlásit někoho, kdo nemá v ROBISu účet (například jen na ubytování a ne na závod), musíš se sám z robisu odhlásit. Pokud je to v soutěži povolené, můžeš založit jednorázovou přihlášku i jako nepřihlášený uživatel. K takto založené přihlášce ale nebudeš mít přístup a případné změny bude za tebe muset udělat pořadatel. 
        </v-expansion-panel-text>
      </v-expansion-panel>


      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak mohu editovat a vytvářet soutěže?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Spravovat soutěž (tvého oddílu) může pouze organizátor oddílu nebo člověk, kterému byl přidělen přístup v nastavení soutěže. Pokud to potřebuješ, požádej o možnost správce oddílu nebo předsedu oddílu a nebo toho, kdo má konkrétní soutěž na starost.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak robis pracuje s vyčítacími programy?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Robis podporuje exporty přihlášených závodníků pro několik programů na vyčítání čipů a zpracování výsledků. Např. program Petra Matuly, chebský OCM, německý FjwW nebo SiDroid. Robis sám výsledky nezpracovává, pouze je z těchto programů převezme pomocí importu. Pokud jsi mezi programy nenašel ten svůj, nebo jsi sám programátor co vyčítací program spravuje a chceš robis integrovat, napiš nám na email info@rob-is.cz. Rádi ti pomůžeme a poradíme.  
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title>
          Jak mám zaplatit za svoji přihlášku?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Robis sice zobrazuje ceny, ale kvůli případným odhláškám nebo změnám fungují platby zatím tak, že částku za tebe pořadateli odešle tvůj oddíl, který se s tebou v budoucnu vyrovná. Platby sám od sebe pořadateli neposílej. Vše zařídí tvůj oddíl.    
        </v-expansion-panel-text>
      </v-expansion-panel>


      <v-expansion-panel>
        <v-expansion-panel-title>
          Je ROBis placený?
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          Robis je zcela zdarma. Jeho provoz (hosting, doména, apod.) je hrazen z darů a příspěvků od lidí, kterým se naše práce líbí a zjednodušuje jim život. Pokud nás chceš podpořit i ty, napiš nám prosím na info@rob-is.cz. Budeme rádi za jakýkoliv příspěvek.
        </v-expansion-panel-text>
      </v-expansion-panel>
                
    </v-expansion-panels>
  </v-col>



</template>


<style scoped>
.text-blue {
  color: #1e88e5;
}
.text-red {
  color: #e53935;
}
.text-primary {
  text-decoration: underline;
  color: #1976d2;
}
.method {
  font-weight: bold;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: bold;
  margin-right: 10px;
}


code {
  background-color: rgb(var(--v-theme-code));
  color: rgb(var(--v-theme-on-code));
  padding: 4px 8px;
  margin-right: 10px;
  border-radius: 4px;
  display: inline-block;
  word-break: break-all;
}
p {
  text-align: justify;
  line-height: 27px;
}
</style>
